import type { ProductKey } from "./schema";

export interface ProductDefinition {
  key: ProductKey;
  label: string;
  /** Libellé court (pastille d'issue « ✓ Closé · Mastery »). */
  shortLabel: string;
  defaultPrice: number;
  defaultCommissionRate: number;
}

// `power_coaching` garde sa clé : les ventes passées (1 500 €) sont du Mastery, montants inchangés.
export const PRODUCTS: Record<ProductKey, ProductDefinition> = {
  power_coaching: {
    key: "power_coaching",
    label: "Power Coaching Mastery",
    shortLabel: "Mastery",
    defaultPrice: 2500,
    defaultCommissionRate: 0.1,
  },
  power_coaching_video: {
    key: "power_coaching_video",
    label: "Power Coaching Vidéo",
    shortLabel: "Vidéo",
    defaultPrice: 1500,
    defaultCommissionRate: 0.1,
  },
  accelerateur: {
    key: "accelerateur",
    label: "Accélérateur",
    shortLabel: "Accélérateur",
    defaultPrice: 590,
    defaultCommissionRate: 0.1,
  },
};

export const PRODUCT_LIST: ProductDefinition[] = Object.values(PRODUCTS);

export const RETRACTATION_DAYS = 14;
